// index.ts
import { degreesToRadians, lengthToRadians, point, radiansToDegrees } from "@turf/helpers";
import { getCoord } from "@turf/invariant";
function destination(origin, distance, bearing) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var coordinates1 = getCoord(origin);
    var longitude1 = degreesToRadians(coordinates1[0]);
    var latitude1 = degreesToRadians(coordinates1[1]);
    var bearingRad = degreesToRadians(bearing);
    var radians = lengthToRadians(distance, options.units);
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) + Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = radiansToDegrees(longitude2);
    var lat = radiansToDegrees(latitude2);
    return point([
        lng,
        lat
    ], options.properties);
}
var turf_destination_default = destination;
export { turf_destination_default as default, destination }; //# sourceMappingURL=index.js.map
